// src/components/Team.js

import React, { useState } from 'react';
import TeamMember from './TeamMember';
import TeamData from '../../data/TeamData';
import styles from './Team.module.css';

function Team() {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <section className={styles.teamSection}>
      <div className={styles.cardContainer}>
        {TeamData.map((profile, i) => (
          <TeamMember
            key={i}
            profile={profile}
            isExpanded={expanded === i}
            onClick={() => toggleExpand(i)}
          />
        ))}
      </div>
    </section>
  );
}

export default Team;
